import ReactDOM from 'react-dom';
import ApolloProvider from './ApolloProvider';
import './index.css';

ReactDOM.render(ApolloProvider, document.getElementById('root'));
